<template>
    <div class="page_no_pms">
        <no-pms></no-pms>
    </div>
</template>

<script>
import noPms from "@/components/NoPms.vue"
export default {
    components:{noPms}
}
</script>


// WEBPACK FOOTER //
// src/pages/PartI/NoPms/index.vue